import { hasPath, isNil, path, prop } from 'ramda';

const exceptionCodePath = ['exception', 'code'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getErrorCode = (error: any): any => {
  const extensions = path(['graphQLErrors', 0, 'extensions'], error);
  if (!isNil(extensions) && hasPath(exceptionCodePath, extensions)) {
    return path(exceptionCodePath, extensions);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return prop<string, any>('code', extensions);
};

export default getErrorCode;
